import React from 'react';

import { Button, Form, Checkbox } from 'semantic-ui-react';
import ZutatenFormTableRowDraggable from './ZutatenFormTableRowDraggable';
import sortDrop from './SortDrop';

const ZutatenForm = ({
  zutaten,
  addZutat,
  handleZutatChange,
  setZutaten, // for drag and drop
  removeZutat,
  zutatengruppen,
  rohstoffeNames,
  produkteNames,
  grundrezepte,
  isIncompleteZutat,
}) => {
  const handleSortUp = (index) => {
    if (index === 0) return; // The first zutat can only be moved down
    const newZutaten = [...zutaten];
    newZutaten[index].sorting -= 1;
    newZutaten[index - 1].sorting += 1;
    handleZutatChange(
      { target: { name: 'sorting', value: newZutaten[index].sorting } },
      index,
    );
    handleZutatChange(
      {
        target: { name: 'sorting', value: newZutaten[index - 1].sorting },
      },
      index - 1,
    );
  };

  const handleSortDown = (index) => {
    if (index === zutaten.length - 1) return; // The last zutat can only be moved up
    const newZutaten = [...zutaten];
    newZutaten[index].sorting += 1;
    newZutaten[index + 1].sorting -= 1;
    handleZutatChange(
      { target: { name: 'sorting', value: newZutaten[index].sorting } },
      index,
    );
    handleZutatChange(
      {
        target: { name: 'sorting', value: newZutaten[index + 1].sorting },
      },
      index + 1,
    );
  };

  /*
   * Note on `handleSortDrop` and setting  the new state:
   *
   * `handleZutatChange` is inherently flawed:
   * multiple calls within the same render overwrite each other,
   * so only the last update is applied.
   *
   * This stems from a misunderstanding of React’s rendering model,
   * and fixing it would require significant refactoring across many components.
   *
   * Since drag-and-drop requires multiple updates, we instead bypass it
   * and use `setZutaten` directly.
   */
  const handleSortDrop = (dragIndex, dropIndex) => {
    const updatedZutaten = sortDrop(zutaten, dragIndex, dropIndex);
    if (updatedZutaten !== zutaten) {
      // Only update if there was a change
      setZutaten(updatedZutaten); // Bypass handleZutatChange and set the new state directly
    }
    setZutaten(updatedZutaten);
  };

  const dndId = React.useRef(Math.random().toString(36).substring(2, 15));

  const handleKeyDown = (e) => {
    // Prevent form submission on "Enter" key press so "delete button" does not get triggered accidentially
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <div className="zutatenForm">
      <div className="row rowHeader">
        <p></p>
        <p>Kategorie</p>
        <p>Zutat</p>
        <p>Menge in g</p>
        <p>Info</p>
        <p>Zutatengruppe</p>
        <p>Backen</p>
        <p>Reihenfolge</p>
        <p>Löschen</p>
      </div>
      {zutaten &&
        zutaten.map((zutat, index) => (
          <ZutatenFormTableRowDraggable
            key={index}
            zutat={zutat}
            zutatengruppen={zutatengruppen}
            index={index}
            zutatenLength={zutaten.length}
            rohstoffeNames={rohstoffeNames}
            produkteNames={produkteNames}
            grundrezepte={grundrezepte}
            handleZutatChange={handleZutatChange}
            handleSortUp={handleSortUp}
            handleSortDown={handleSortDown}
            handleSortDrop={handleSortDrop}
            dndId={dndId.current}
            removeZutat={removeZutat}
          />
        ))}

      <div className="row add">
        <Button onClick={addZutat} disabled={isIncompleteZutat}>
          Zutat Hinzufügen
        </Button>
      </div>
    </div>
  );
};

export default ZutatenForm;
